module.exports = __webpack_public_path__ + "static/media/rebalance_report.027c7458.svg";